import { useCallback, useState, useContext, useEffect, useRef } from "react";

import { TostMsg } from "../../../App";

import { getEmployeeList } from "../EmployeeList/Service/employeeService";

import { useParams } from "react-router-dom/cjs/react-router-dom";
import { Button } from "bootstrap/dist/js/bootstrap.bundle.min";

const AddnewEmployee = () => {
  const [columns, setColumns] = useState([
    "Employee Name",
    "First Reviewer",
    "Second Reviewer",
    "Hr",
    "Action",
  ]); // Columns state

  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");

  const [Isloading, setIsloading] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);

  let toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [errors, setErrors] = useState({});
  const { GUID } = useParams();

  useEffect(() => {
    getEmployeeIdData();
  }, []);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  async function getEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    setIsloading(true);
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeeList(employeesList.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  return (
    <div>
      {/* {" "} */}
      <div>
        <div className="flex flex-column h-12rem">
          <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
            <div className="title-text" style={{ position: "relative" }}>
              <h4>Add Employee</h4>

              <button
                className="addaward-btn"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-bs-original-title=""
                fdprocessedid="izng1j"
                // onClick={handleAddRow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                Employee
              </button>
            </div>
            <table className="table table-bordered table-hover" id="tab_logic">
              <thead>
                <tr>
                  <th className="text-center">#</th>
                  {columns.map((colName, colIdx) => (
                    <th key={colIdx} className="text-left">
                      {colName}
                    </th>
                  ))}
                  {/* <th className="text-left" style={{ width: "100px" }}>
                    Action
                  </th> */}
                </tr>
              </thead>

              <tbody>
                {/* {orgAwardList?.map((data, index) => ( */}
                {/* key={index} */}
                <tr>
                  <td className="text-center">{/* {index + 1} */}</td>
                  {/* {editIndex === index ? ( */}
                  
                    <td>
                      <select className={`form-control`}>
                        <option>Choose...</option>

                        {employeeList?.map((employee) => (
                          <option key={employee.Id} value={employee.EmpId}>
                            {employee.FullName}
                          </option>
                        ))}
                      </select>
                      {/* {errors[`${index}-AwardName`] && (
                                    <div className="invalid-feedback">
                                      {errors[`${index}-AwardName`]}
                                    </div>
                                  )} */}
                    </td>

                    <td>
                      <select
                        // onChange={(e) => {
                        //   const selectedId = e.target.value;
                        //   SetSelectedId(selectedId);
                        //   const selectedOption =
                        //     awardFrequencyLst.find(
                        //       (opt) =>
                        //         Number(opt.Id) ===
                        //         Number(selectedId)
                        //     );
                        //   handleChange(
                        //     index,
                        //     "FrequencyName"
                        //   )({
                        //     target: {
                        //       value: selectedOption?.Name || "",
                        //     },
                        //   });
                        // }}
                        // value={
                        //   awardFrequencyLst.find(
                        //     (opt) => opt.Name === data.FrequencyName
                        //   )?.Id || ""
                        // }
                        className={`form-control 
                                   
                                    `}
                      >
                        <option value="" disabled>
                          Choose...
                        </option>
                        {/* {awardFrequencyLst?.map((option) => (
                                      <option key={option.Id} value={option.Id}>
                                        {option.Name}
                                      </option>
                                    ))} */}
                      </select>
                      {/* {errors[`${index}-FrequencyName`] && (
                                    <div className="invalid-feedback">
                                      {errors[`${index}-FrequencyName`]} */}
                      {/* </div> */}
                      {/* )} */}
                    </td>

                    <td>
                   
                      <div className="loadresumes">
                        <div className="inner"></div>

                        <select className={`form-control`}>
                          <option>Choose...</option>
                        </select>
                      </div>
                    </td>

                    <td>
                     
                        <select className={`form-control`}>
                          <option>Choose...</option>
                        </select>
                     
                    </td>
                    <td></td>
               
                  {/* ) : (
                  <>
                    <td>mohit</td>
                    <td>Megha</td>
                    <td>Arun</td>
                    <td className=""></td>

                    <td className="">
                      <button
                        // disabled={editIndex != null}
                        className="editactions me-2"
                        // onClick={() => handleEditClick(index)}
                      >
                        <img
                          src="/images/tickets/edit-ico.svg"
                          className=""
                          title="Edit"
                        />
                      </button>
                      <button
                        className="editactions"
                        title="Delete"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-Award"
                        // onClick={() => {
                        //   handleCreatedlstDelete(data?.id);
                        //   GetMasterSystemAlertList(
                        //     "Delete_Award",
                        //     1
                        //   );
                        // }}
                      >
                        <img
                          src="/images/tickets/delete.svg"
                          className=""
                          title="Delete"
                        />
                      </button>
                    </td>
                  </> */}
                  {/* )} */}
                </tr>
                {/* ))} */}
              </tbody>
            </table>
          </div>
        </div>
        <div className="flex pt-5 justify-content-between text-right">
          {/* <Button
            label="Back"
            severity="secondary"
            className="cancelbutton bg-dark text-white"
            // onClick={() => stepperRef.current.prevCallback()}
          />
          <Button label="Save and Exit" className="savebutton w-auto" /> */}
        </div>
      </div>
    </div>
  );
}

export default AddnewEmployee;
